import * as BookingTrigger from './trigger-definition'
export { BookingTrigger }
